import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: '"Kulim Park", "Arial", sans-serif', // Use Kulim Park font
    allVariants: {
      color: "#000", // Set default text color to black
    },
  },
});

export default theme;